// A ‘.tsx’ file enables JSX support in the TypeScript compiler, 
// for more information see the following page on the TypeScript wiki:
// https://github.com/Microsoft/TypeScript/wiki/JSX

import React from 'react';
import { createRoot, Root } from 'react-dom/client';
interface ModalSliderProps extends React.PropsWithChildren<{}> {
    isOpen: boolean;
    onClose: any;
    slideRight?: boolean;
    containerStyle?: string;
}

class ModalSlider extends React.Component<ModalSliderProps, any> {
    
    portal: HTMLDivElement;
    portalContainer: HTMLElement;
    closing: boolean;
    private _root: Root | null = null;

    constructor(props: ModalSliderProps) {
        super(props);

    }
    
    private _checkEvent = (event: Event) => {
        if ($(event.target).is('.cd-panel')) {
            this.props.onClose();
        }
    }

    private renderModalContent = (props: ModalSliderProps) => {
        if (props.isOpen) {
            if (!this.portal) {
                this.closing = false;
                this.portal = document.createElement('div');
                this.portal.className = `cd-panel ${this.props.slideRight ? 'from-left' : 'from-right'}`;
                this.portal.onclick = this._checkEvent;

                this.portalContainer.appendChild(this.portal);
                let containerStyle = props.containerStyle ? props.containerStyle : '';
                this._root = createRoot(this.portal);
                this._root.render(<div className={`cd-panel-container ${containerStyle}`}><div className="cd-panel-content">{props.children}</div></div>);
                setTimeout(() => {
                    $(this.portal).addClass('is-visible');
                }, 1);
            } else {
                let containerStyle = props.containerStyle ? props.containerStyle : '';
                if (containerStyle && containerStyle === 'collapse-left') {
                    if ($(this.portal).find('.expanded-left')) $(this.portal).find('.expanded-left').first().removeClass("expanded-left").addClass("collapse-left");
                } else if (containerStyle && containerStyle === 'expanded-left')  {
                    if ($(this.portal).find('.collapse-left')) $(this.portal).find('.collapse-left').first().removeClass("collapse-left").addClass("expanded-left");
                }
            }
        } else if (this.portal && !this.closing) {
            this.closing = true;
            $(this.portal).removeClass('is-visible');
            setTimeout(() => {
                this._root?.unmount();
                this._root = null;
                this.portal.onclick = null;
                $(this.portal).remove();
                this.portal = null;
                this.closing = false;
            }, 500);
        }
    }

    componentDidMount() {
        this.portalContainer = document.getElementById('inovx-modal-pop-up');
        if (!this.portalContainer) {
            this.portalContainer = document.createElement('div');
            this.portalContainer.id = 'inovx-modal-pop-up';
            document.body.appendChild(this.portalContainer);
        }

        this.renderModalContent(this.props);
    }

    UNSAFE_componentWillReceiveProps(nextProps: ModalSliderProps) {
        this.renderModalContent(nextProps);
    }

    componentWillUnmount() {
        if (this.portal && !this.closing) {
            this._root?.unmount();
            this._root = null;
            this.portal.onclick = null;
            $(this.portal).remove();
            this.portal = null;
        }
    }

    render(): any {
        return null;
    }

}

export default ModalSlider;